import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ScreenAboutLook as ScreenAboutLookFemale } from '../../../OwnAI/screens/AboutLook';
import { ScreenAboutLook as ScreenAboutLookMale } from '../../../OwnAIMan/screens/AboutLook';
import { LayoutDataType } from '../../types';

export const ScreenAboutLook: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenAboutLookMale />;
  }

  return <ScreenAboutLookFemale />;
};
